import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCurveEasing24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconCurveEasing24"
            aria-hidden="true"
            {...props}
        >
            <g fill="currentColor">
                <path d="M17.25 7.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5M18 9.75a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m0 3a.75.75 0 0 0-1.5 0 3.75 3.75 0 0 1-3.75 3.75h-6a.75.75 0 0 0 0 1.5h6c2.9 0 5.25-2.35 5.25-5.25" />
                <path
                    fillRule="evenodd"
                    d="M3 6.273A3.273 3.273 0 0 1 6.273 3h11.454A3.273 3.273 0 0 1 21 6.273v11.454A3.273 3.273 0 0 1 17.727 21H6.273A3.273 3.273 0 0 1 3 17.727zM6.273 4.5h11.454c.98 0 1.773.794 1.773 1.773v11.454c0 .98-.794 1.773-1.773 1.773H6.273A1.773 1.773 0 0 1 4.5 17.727V6.273c0-.98.794-1.773 1.773-1.773"
                    clipRule="evenodd"
                />
            </g>
        </svg>
    );
}
export default memo(IconCurveEasing24);
